import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../Components/Button/Button";
import { blogData } from "../../redux/blogs/blogSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./Blog.css";
import { getBlogById , clearBlogSliceStates,
  clearBlogSliceData,
  clearBlogDetailData,
  clearBlogUserData,
  clearBlogSliceMessages} from "../../redux/blogs/blogSlice";
import ComponentLoader from "../../Components/loaders/ComponentLoader/ComponentLoader";

const Blog = () => {
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogSliceSuccess,
    isBlogSliceError,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
  
    blogDetail,
  } = useSelector((state) => state.blog);
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id")
  console.log("id",id)
  useEffect(() => {
    if (id) {
      dispatch(getBlogById( {id} ));
      console.log("bg",blogDetail)
      return () => {
         dispatch(clearBlogDetailData())
        dispatch(clearBlogSliceMessages())
      }
    }
  }, [id]);

  return (
    <>
      <div className="wrapperBox doubleMenu newStyling">
        {isBlogSliceFetching ? (
          <ComponentLoader />
        ) : (
          <>
          <div className="entry-header">
            <div className="entry-categories">
              <h6>{blogDetail?.blog_Type}</h6>
              <h1 class="entry-title">{blogDetail?.blog_Title}</h1>
              <ul class="entry-meta">
                {/* <li class="item-author">
                  by{" "} {blogDetail?.user ? blogDetail?.user[0]?.firstName  : " "}         
                  &nbsp;
                </li> */}

                <li>
                  <i class="far fa-calendar-alt"></i>
                  {moment(blogDetail?.blog_CreatedOn).format("MMM D YYYY")}
                  &nbsp;
                </li>
                <li class="meta-reading-time meta-item">
                  <i class="far fa-clock"></i>
                  <span class="meta-reading-time meta-item">
                    {blogDetail?.blog_readingTime} minutes read
                  </span>
                </li>
              </ul>
            </div>
          </div>
        

        <div className="entry-thumbnail-area">
          {/* <img
          width="1024"
          height="585"
          src={blogDetail?.thumbNail}
          alt={blogDetail?.blog_Title}
          className="img-responsive wp-post-image"
          decoding="async"
        /> */}
        </div>

        <div
          dangerouslySetInnerHTML={{ __html: blogDetail?.blog_Body }}
          className="scoped-content-wrapper"
        />

        <div class="entry-footer">
          <div class="entry-footer-meta">
            <div class="meta-tags">
              <h4 class="meta-title">Tags:</h4>

              <div className="tableData">{blogDetail?.tags?.join(", ")}</div>
            </div>
          </div>
        </div>
        </>
        )}
      </div>
    </>
  );
};

export default Blog;


